import {
  EChatActionTypes,
  TDisableSendDefaultMessagePayload,
  TEditableMessagePayload,
  TBubbleInputFocusPayload,
  TIncomingMessagePayload,
  TSetCaptchaTokenPayload,
} from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const addIncomingMessage = actionGenerator<EChatActionTypes.IncomingMessage, TIncomingMessagePayload>(
  EChatActionTypes.IncomingMessage,
);

export const setEditableMessage = actionGenerator<EChatActionTypes.SetEditableMessage, TEditableMessagePayload>(
  EChatActionTypes.SetEditableMessage,
);

export const setCaptchaToken = actionGenerator<EChatActionTypes.SetCaptchaToken, TSetCaptchaTokenPayload>(
  EChatActionTypes.SetCaptchaToken,
);

export const disableSendDefaultMessage = actionGenerator<
  EChatActionTypes.DisableSendDefaultMessage,
  TDisableSendDefaultMessagePayload
>(EChatActionTypes.DisableSendDefaultMessage);

export const setBubbleInputFocus = actionGenerator<EChatActionTypes.SetBubbleInputFocus, TBubbleInputFocusPayload>(
  EChatActionTypes.SetBubbleInputFocus,
);
